import { Component, OnInit } from '@angular/core';
import { FormBuilder, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { UtilityService } from 'src/app/services/utility.service';
import { ThemeService } from 'src/app/services/theme.service';
import { environment } from 'src/environments/environment';
import { messages } from '../../../../../common/messages'
import { regex,EmailNoWhitespaceValidator } from '../../../../../common/regex'

@Component({
    selector: 'app-admin-forgot-password',
    templateUrl: './admin-forgot-password.component.html',
    styleUrls: ['./admin-forgot-password.component.scss'],
    standalone: false
})
export class AdminForgotPasswordComponent implements OnInit {

  assets = environment.assets;
  emailRegex = regex.pattern.EMAIL
  public form: any;
  message: any;
  logoPath: string = '';

  constructor(
    public router: Router,
    private fb: FormBuilder,
    private utility: UtilityService,
    private api: ApiService,
    public themeService: ThemeService) { }

  ngOnInit(): void {
    this.setupForgotPasswordForm();
    this.message = messages
    this.logoPath = this.themeService.getLogoPath();
  }

  setupForgotPasswordForm() {
    this.form = this.fb.group({
      email: ['',
        Validators.compose([
          Validators.required,
          EmailNoWhitespaceValidator])],
    });
  }

  checkEmail() {

    if (this.form.controls.email.status === "VALID") {
      this.utility.setSpinner(true);
      let emailDetails = {
        email: this.form.value.email.toLowerCase(),
        userType: "admin",
      }
      this.api.apiRequest("post", "user/getUserByEmail", emailDetails)
        .subscribe(res => {
          this.utility.setSpinner(false);

          if (res.status == "success") {
            this.form.controls["email"].setErrors(null);
            this.onSubmit();
          }
          else if (res.status == "differentUser") {
            this.form.controls["email"].setErrors({ differentEmail: true });

          } else {
            this.form.controls["email"].setErrors({ invalidEmail: true });

          }
        }, (err) => {
          this.utility.setSpinner(false);
        })
    }
  }
  onSubmit() {
    this.utility.setSpinner(true);
    let emailDetails = { email: this.form.value.email.toLowerCase() }
    this.api.apiRequest("post", "user/forgotPassword", emailDetails)
      .subscribe(res => {
        this.utility.setSpinner(false);
        if (res.data.message == "Reset password link sent") {
          // this.setupForgotPasswordForm();
          this.form.controls['email'].setValue('');
          this.form.controls['email'].markAsUntouched();
          this.form.controls["email"].setErrors(null);
          this.utility.openSnackBar("Link to reset password is sent to your registered email Id.", "Ok")
        }
        else if (res.status == 'userNotFound') {
          this.form.controls["email"].setErrors({ invalidEmail: true });
        }
        else {
          let msg = 'Something went wrong.'
          this.utility.openSnackBar(msg, 'Ok')
        }
      }, (err) => {
        this.utility.setSpinner(false);

      })
  }

}
